import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { JsonLd } from "./SEO";
import { useI18n } from "../i18n";

export default function Breadcrumbs({ items }) {
  const { t } = useI18n();
  const jsonld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem", position: i + 1,
      name: typeof it.label === "object" ? it.label.es : it.label,
      item: `https://altamiravenezuela.com${it.href || ""}`,
    })),
  };
  return (
    <>
      <JsonLd data={jsonld} />
      <div className="crumb" data-testid="breadcrumbs" role="navigation" aria-label="Breadcrumb">
        {items.map((it, i) => (
          <span key={i}>
            {i > 0 && <ChevronRight size={12} style={{ display: "inline", verticalAlign: "-1px", margin: "0 6px", opacity: 0.6 }} />}
            {it.href ? <Link to={it.href}>{t(it.label)}</Link> : <span>{t(it.label)}</span>}
          </span>
        ))}
      </div>
    </>
  );
}
